import { reducer } from '../reducers/useTraineeshipsFiltersReducer';
import { useReducer, useCallback } from 'react';
import {
    SET_STATUS_ACTION,
    SET_STUDENT_FIRST_NAME_ACTION,
    SET_STUDENT_LAST_NAME_ACTION,
    SET_CREATED_BY_STUDENT_ACTION,
    SET_ERASMUS_CODE_ACTION,
    SET_COUNTRY_ACTION,
    SET_EXPAND_FILTERS_ACTION,
    SET_SELECTED_FILTERS_LIST_ACTION,
    SET_SORT_BY_ACTION,
    UPDATE_MULTIPLE_VALUES_ACTION,
    SET_ISCED_ID_ACTION,
    SET_TRAINEESHIP_ID_ACTION,
    SET_RECEIVING_ORGANIZATION_ACTION,
    SET_RECEIVING_COUNTRY_ACTION,
    SET_SENDING_CONTACT_FIRST_NAME_ACTION,
    SET_SENDING_CONTACT_LAST_NAME_ACTION
} from '../reducers/useTraineeshipsFiltersReducer';

// fallback state
export const defaultState = {
  status: "",
  studentFirstName: "",
  studentLastName: "",
  sendingErasmusCode: "",
  sendingCountry: [],
  createdByStudent: "",
  iscedId: "",
  traineeshipId: "",
  receivingOrganization: "",
  receivingCountry: "",
  sendingContactFirstName: "",
  sendingContactLastName: "",
  selectedFiltersList:[],
  sortBy:"changed_descending",
  expandFilters: false
}

/**
 * Used to handle filters for Traineeship queries
 * 
 * @param {Object} initialState the initial state of the filters, fallbacks to a default state with empty string and lists if no initial state is provided
 * @returns Filters state as well as handlers for changing the state
 */
export const useTraineeshipsFilters = (initialState = defaultState) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const setCreatedByStudent = useCallback((data) => {
        dispatch({ type: SET_CREATED_BY_STUDENT_ACTION, payload: { createdByStudent: data } });
    }, []);

    const setSendingCountry = useCallback((data) => {
        dispatch({ type: SET_COUNTRY_ACTION, payload: { sendingCountry: data } });
    }, []);

    const setSendingErasmusCode = useCallback((data) => {
        dispatch({ type: SET_ERASMUS_CODE_ACTION, payload: { sendingErasmusCode: data } });
    }, []);

    const setStudentFirstName = useCallback((data) => {
        dispatch({ type: SET_STUDENT_FIRST_NAME_ACTION, payload: { studentFirstName: data } });
    }, []);

    const setStudentLastName = useCallback((data) => {
        dispatch({ type: SET_STUDENT_LAST_NAME_ACTION, payload: { studentLastName: data } });
    }, []);

    const setStatus = useCallback((data) => {
        dispatch({ type: SET_STATUS_ACTION, payload: { status: data } });
    }, []);

    const setExpandFilters = useCallback((data) => {
        dispatch({ type: SET_EXPAND_FILTERS_ACTION, payload: { expandFilters: data } });
    }, []);

    const setSelectedFiltersList = useCallback((data) => {
        dispatch({ type: SET_SELECTED_FILTERS_LIST_ACTION, payload: { selectedFiltersList: data } });
    }, []);

    const setSortBy = useCallback((data) => {
        dispatch({ type: SET_SORT_BY_ACTION, payload: { sortBy: data } });
    }, []);

    const updateMultipleValues = useCallback((data) => {
        dispatch({ type: UPDATE_MULTIPLE_VALUES_ACTION, payload: data })
    }, []);

    const setIscedId = useCallback((data) => {
        dispatch({ type: SET_ISCED_ID_ACTION, payload: { iscedId: data } });
    }, []);

    const setTraineeshipId = useCallback((data) => {
        dispatch({ type: SET_TRAINEESHIP_ID_ACTION, payload: { traineeshipId: data } });
    }, []);

    const setReceivingOrganization = useCallback((data) => {
        dispatch({ type: SET_RECEIVING_ORGANIZATION_ACTION, payload: { receivingOrganization: data } });
    }, []);

    const setReceivingCountry = useCallback((data) => {
        dispatch({ type: SET_RECEIVING_COUNTRY_ACTION, payload: { receivingCountry: data } });
    }, []);

    const setSendingContactFirstName = useCallback((data) => {
        dispatch({ type: SET_SENDING_CONTACT_FIRST_NAME_ACTION, payload: { sendingContactFirstName: data } });
    }, []);

    const setSendingContactLastName = useCallback((data) => {
        dispatch({ type: SET_SENDING_CONTACT_LAST_NAME_ACTION, payload: { sendingContactLastName: data } });
    }, []);

    return {
        state,
        setCreatedByStudent,
        setSendingCountry,
        setSendingErasmusCode,
        setStudentLastName,
        setStudentFirstName,
        setStatus,
        setExpandFilters,
        setSelectedFiltersList,
        setSortBy,
        updateMultipleValues,
        setIscedId,
        setTraineeshipId,
        setReceivingOrganization,
        setReceivingCountry,
        setSendingContactFirstName,
        setSendingContactLastName
    };
}